import React from "react";
import styled from "styled-components";

const FooterContainer = styled.footer`
  background: #000;
  border-top: 1px solid rgba(220, 38, 38, 0.3);
  padding: 60px 20px 40px;
  text-align: center;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const CompanySection = styled.div`
  margin-bottom: 40px;
`;

const CompanyName = styled.h3`
  font-size: 1.8rem;
  font-weight: 700;
  color: #dc2626;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &::before {
    content: "⚡";
    font-size: 2rem;
  }
`;

const CompanyDescription = styled.p`
  font-size: 1.1rem;
  color: #666;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
`;

const Copyright = styled.div`
  padding-top: 30px;
  border-top: 1px solid rgba(220, 38, 38, 0.2);
  color: #888;
  font-size: 0.9rem;
  
  p {
    margin: 0;
    line-height: 1.4;
  }
`;

const FooterSimple = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <CompanySection>
          <CompanyName>beatt pulse</CompanyName>
        </CompanySection>

        <Copyright>
          <p>© 2025 beatt. Todos os direitos reservados.</p>
        </Copyright>
      </FooterContent>
    </FooterContainer>
  );
};

export default FooterSimple;